import { joinDataTestId } from "@/constants/data-test-ids.utils";

const component = "subscription-history";

export const subscriptionHistoryDataTestIds = {
  component,
  drawer: joinDataTestId(component, "drawer"),
  statusFilter: joinDataTestId(component, "status-filter"),
  resultCount: joinDataTestId(component, "result-count"),
  skeleton: joinDataTestId(component, "skeleton"),
  emptyState: joinDataTestId(component, "empty-state"),
  errorState: joinDataTestId(component, "error-state"),
  truncationNotice: joinDataTestId(component, "truncation-notice"),
  entry: (id: number): string => joinDataTestId(component, "entry", String(id)),
  entryToggleCta: (id: number): string => joinDataTestId(component, "entry-toggle-cta", String(id)),
  entryDetails: (id: number): string => joinDataTestId(component, "entry-details", String(id)),
  entryCurrentBadge: (id: number): string => joinDataTestId(component, "entry-current-badge", String(id)),
};
